/** 自治体設定API(query)のリクエスト */
export interface ArgQueryGovernmentSettings {
  system: string
  govCode: string
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isArgQueryGovernmentSettings = (arg: any): boolean => {
  return (
    arg !== null &&
    typeof arg === 'object' &&
    typeof arg.system === 'string' &&
    typeof arg.govCode === 'string'
  )
}

/** 自治体設定API(query)のレスポンス */
export interface ResQueryGovernmentSettings {
  system: string
  govCode: string
  upperLimitQuantityOfInspection?: number
  serviceLimitEnable?: boolean
  manualUrl?: string
  isDeviceAuthentication: boolean // 【デバイス認証】
}

export interface resQueryGovernment {
  result: ResQueryGovernmentSettings
}

export const FEATURE_OPTIONS = {
  /** スクリーニング */
  screeningAuth: 'ScreeningAuth',
  /** 自己判定 */
  selfJudgeAuth: 'SelfJudgeAuth',
  /** 帳票出力ツール */
  formToolAuth: 'FormToolAuth',
  /** 平面図 */
  floorPlanAuth: 'FloorPlanAuth',
  /** 応急危険度判定アプリ */
  emergencyAuth: 'EmergencyAuth'
} as const

export type FeatureOptions = (typeof FEATURE_OPTIONS)[keyof typeof FEATURE_OPTIONS]
